/**
 * API Configuration
 * Centralized API endpoint configuration for all services.
 *
 * All service URLs come from serviceConfig.ts (single source of truth).
 * To change a port or URL, update ONLY the .env file.
 */

import { SERVICE_URLS, getServiceUrl } from '../config/serviceConfig';

// Re-export service URLs for backward compatibility
export const API_URLS = SERVICE_URLS;

// Build endpoint URLs
export const API_ENDPOINTS = {
  // Gaushala Service endpoints
  gaushala: {
    getBankAccount: (gaushalaId: number) => `${API_URLS.gaushala}/api/v1/gaushala/bank-accounts/${gaushalaId}/bank-account`,
    getBankAccountCurrent: `${API_URLS.gaushala}/api/v1/gaushala/bank-accounts`,
    createBankAccount: `${API_URLS.gaushala}/api/v1/gaushala/bank-accounts`,
    updateBankAccount: `${API_URLS.gaushala}/api/v1/gaushala/bank-accounts`,
    getGaushalaName: (gaushalaId: number) => `${API_URLS.gaushala}/api/v1/gaushalas/${gaushalaId}/name`,
  },

  // Manufacturing Service endpoints
  manufacturing: {
    base: `${API_URLS.manufacturing}/api/v1`,
    getProfile: () => `${API_URLS.manufacturing}/api/v1/dashboard/my-unit`,
    getTransactions: `${API_URLS.manufacturing}/api/v1/transactions`,
    getTransaction: (id: number) => `${API_URLS.manufacturing}/api/v1/transactions/${id}`,
    getPayments: `${API_URLS.manufacturing}/api/v1/payments`,
    getPayment: (id: number) => `${API_URLS.manufacturing}/api/v1/payments/${id}`,
  },

  // Other services can be added here as needed
};

/**
 * Get authorization header
 * Retrieves JWT token from localStorage and returns authorization header
 */
export const getAuthHeader = () => {
  const token = localStorage.getItem('saubhagya_jwt_token');
  if (!token) {
    return {};
  }
  return {
    Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
  };
};

/**
 * Fetch with authorization
 * Wrapper around fetch that automatically includes auth headers
 */
export async function fetchWithAuth(
  endpoint: string,
  options: RequestInit = {}
) {
  const headers = {
    'Content-Type': 'application/json',
    ...getAuthHeader(),
    ...options.headers,
  };

  const response = await fetch(endpoint, {
    ...options,
    headers,
  });

  return response;
}
